import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { getInsightsPosition } from './positioning';

const InsightsToggleButton = props => {
    const { insights_toggle_button, toggleInsightsOpen, insightsOpen, insights_dark_theme } = props;


    const themeModalClass = insights_dark_theme ? 'dark' : 'light';

    const position = useMemo(() => {
        return getInsightsPosition(insights_toggle_button?.position);
    }, [insights_toggle_button?.position]);

    // If modal insights_dark_theme is set, use it
    // Otherwise, use the toggle button theme
    const themeClass = useMemo(() => {
        const toggleTheme = insights_toggle_button?.dark_theme;

        if (toggleTheme === true) {
            return "dark";
        } else if (toggleTheme === false) {
            return "light";
        } else {
            // If toggle theme and insights_dark_theme are both undefined, use "dark"
            return themeModalClass;
        }
    }, [insights_toggle_button?.dark_theme, insights_dark_theme]);

    const activeClass = insightsOpen ? 'active' : '';

    const hiddenClass = insights_toggle_button?.show_on_hover ? 'insights-toggle-button-hidden' : ''; //  && !insightsOpen 
    return (
        <div
            className={`insights-toggle-button ${themeClass} ${activeClass} ${hiddenClass}`}
            onClick={toggleInsightsOpen}
            style={position}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
            >
                <rect x="9" y="6.5" width="8" height="9" />
                <path d="M7.941 18c-.297-1.273-1.637-2.314-2.187-3a8 8 0 1 1 12.49.002c-.55.685-1.888 1.726-2.185 2.998H7.941ZM16 20v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-1h8Zm-3-9.995V6l-4.5 6.005H11v4l4.5-6H13Z" />
            </svg>
        </div>
    );
};

InsightsToggleButton.propTypes = {
    // insights_toggle_button: Insights.insights.toggle,
    insights_toggle_button: PropTypes.shape({
        position: PropTypes.oneOf([
            'top-left',
            'top-right',
            'top-middle',
            'bottom-left',
            'bottom-right',
        ]),
        dark_theme: PropTypes.bool,
        show_on_hover: PropTypes.bool
    }),
    toggleInsightsOpen: PropTypes.func,
    insightsOpen: PropTypes.bool,
    insights_dark_theme: PropTypes.bool,
};
export default InsightsToggleButton;
